var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserList = function SvgUserList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M9.5 5a.5.5 0 0 1 .5-.5h5.5a.5.5 0 1 1 0 1H10a.5.5 0 0 1-.5-.5m6 2.5H10a.5.5 0 0 0 0 1h5.5a.5.5 0 1 0 0-1m0 3h-4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1m-6.016 1.375a.5.5 0 0 1-.97.25C8.13 10.629 6.62 9.5 5 9.5s-3.13 1.128-3.515 2.625a.5.5 0 1 1-.97-.25c.35-1.357 1.366-2.456 2.655-3a3 3 0 1 1 3.66 0c1.29.544 2.306 1.643 2.655 3M5 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default SvgUserList;